export const CampaignStatus = {
    STATUS_ACTIVE: 1,
    STATUS_INACTIVE: 2,
    STATUS_PREPARING: 3,
    STATUS_PAUSED: 4,
    STATUS_FINISHED: 5,
    value: {
        1: 'Active',
        2: 'Inactive',
        3: 'Preparing',
        4: 'Paused',
        5: 'Finished'
    },
    label: {
        1: 'label-success',
        2: 'label-info',
        3: 'label-warning',
        4: 'label-danger',
        5: 'bg-inverse'
    }
};

export const CampaignType = {
    PMTA: 1,
    SMTP: 2,
    select: [
        {id: 1, label: 'PMTA'},
        {id: 2, label: 'SMTP'},
    ],
    value: {
        1: 'PMTA',
        2: 'SMTP'
    },
};

export const RelayStatus = {
    NEUTRAL: 1,
    GOOD: 2,
    POOR: 3,
    value: {
        1: 'Neutral',
        2: 'Good',
        3: 'Poor'
    },
    data: [
        {id: 1, label: 'Neutral'},
        {id: 2, label: 'Good'},
        {id: 3, label: 'Poor'}
    ],
    buttons: {
        1: 'btn-secondary',
        2: 'btn-success',
        3: 'btn-danger'
    },
};

export const LinkGroupType = {
    OFFER: 0,
    UNSUBSCRIBE: 1,
    PIXEL: 2,
    value: {
        0: 'Offer',
        1: 'Unsubscribe',
        2: 'Pixel'
    },
    data: [
        {id: 0, label: 'Offer'},
        {id: 1, label: 'Unsubscribe'},
        {id: 2, label: 'Pixel'}
    ]
};

export const IpVersion = {
    IPV4: 'ipv4',
    IPV6: 'ipv6',
    value: {
        1: 'ipv4',
        2: 'ipv6'
    },
    versions: {
        'ipv4': {id: 1, label: 'ipv4'},
        'ipv6': {id: 2, label: 'ipv6'},
    },
    data: [
        {id: 1, label: 'ipv4'},
        {id: 2, label: 'ipv6'}
    ]
};

export const BalancerStatus = {
    UPLOADED: 1,
    UPLOAD_FAILED: 2,
    REMOVED: 3,
    value: {
        1: 'Uploaded',
        2: 'Upload failed',
        3: 'Removed'
    },
    data: [
        {id: 1, label: 'Uploaded'},
        {id: 2, label: 'Upload failed'},
        {id: 3, label: 'Removed'}
    ]
};

export const JsonHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/ld+json'
};

export const FileType = {
    SOCKS: 1,
    SMTP_RELAYS: 2,
    PMTA_RELAYS: 3,
    UNSUBSCRIBERS: 4,
    EMAILS: 5,
    PMTA_RELAYS_ALLIN: 7,
    PMTA_SERVERS_SIMPLE: 8,
    PMTA_SERVERS_WITH_RELAYS: 9
};
